/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * Model for keeping track of urgency contacts
 * Expects config to contain `users`, an instance of UserData
 * @type {Model}
 */


var Model = require("../types/Model.js");

module.exports = Model({
	name: "urgencycontacts",
	init: init,
	listeners: listeners,

	refresh: refresh_urgency_contacts
});

function init() {
	this.refresh();

	this.push([]);
}

function listeners() {
	return {
		"mqtt:$/urgency/add": addContact,
		"mqtt:$/urgency/remove": removeContact,
		"connectivity:online": refresh_urgency_contacts
	};
}

function refresh_urgency_contacts() {
	return this.api.urgency.list()
		.then(this.push.bind(this));
}

function addContact(data) {
	var contact = data.who;
	this.push(this.data.concat(contact));
}

function removeContact(data) {
	var removed = data.who;
	this.push(this.data.filter(function (existing) {
		return existing !== removed;
	}));
}
